<div class='judgesSearchContainer'>
  <div class='judgesSearchHeader'>
    <h1>Судьи</h1>
  </div>
  <div class='judgesSearch'>
    <label
      for='judgeSearchInput'
      class='judgesSearchLabel'
    >
      Судья
    </label>
    <input
      id='judgeSearchInput'
      type='text'
      [ngModel]="getTypedPlayer()"
      (ngModelChange)="handleInputChange($event)"
      [placeholder]="searchPlaceHolder"
    >
  </div>
  <div
    *ngIf="!judgesWereSelected()"
    class="notification"
  >
    Для создания турнира необходимо выбрать судей
  </div>
  <div *ngIf="judgesWereSelected()">
    <div
      class="judgesSearchHeader"
    >
      Выбранные судьи:
    </div>
    <div class="judgesSelectedList">
      <div
        *ngFor="let judge of getJudgesList(); index as i"
        class="judgeSelected"
      >
        <div
          [ngClass]="judgeStyleOnHover(i)"
        >
          {{judge.full_name}}
        </div>
        <div>
          <div
            class="iconButtonSection"
            (click)="onJudgeDelete(i)"
          >
            <mat-icon
              (mouseover)="setIndexOnHover(i)"
              (mouseout)="clearIndexOnHover()"
            >
              close
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="getSearchResults() && !noResults()"
    class="tableContainer"
  >
    <table>
      <thead
        class="tableHeader"
      >
        <tr>
          <th scope="col"></th>
          <th
            scope="col"
          >
            Участник
          </th>
          <th
            scope="col"
          >
            Г.р.
          </th>
          <th
            scope="col"
          >
            Зв.
          </th>
          <th
            scope="col"
          >
            Страна, город
          </th>
        </tr>
      </thead>
      <tbody>
      <tr *ngFor="let player of getSearchResults(); let i = index">
        <td class="td100">
          <button id="add_judge_button_id"
            *ngIf="canRegisterAnotherJudge()"
            class="btn btn-sm btn-primary"
            (click)="addJudge(player, i)"
          >
            Добавить судью
          </button>
        </td>
        <td class="td100">
          <div class="fs14">{{ player.full_name }}</div>
        </td>
        <td class="td100">{{ player.birthdate | amDateFormat : 'DD.MM.YYYY' }}</td>
        <td class="td100">{{ player.title || '' }}</td>
        <td class="td100">
          <div class="location" [class.no-icon]="player.city.region.country.a2code" *ngIf="player.city">
            <span class="fi fi-{{ player.city.region.country.a2code }}" *ngIf="player.city.region.country.a2code"></span>
            {{ player.city.name }}, {{ player.city.region.name }}, {{ player.city.region.country.name }}
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div
    *ngIf="noResults()"
    class="noResultsNotification"
  >
    Кандидаты в судьи не найдены
  </div>
</div>
